import { Component } from '@angular/core';

@Component({
  selector: 'app-hourly-award-cta-layout',
  template: `
    <fl-bit class="HourlyAwardCTA-switchAwardTypeButton">
      <ng-content
        select="[hourly-award-cta-switch-award-type-button]"
      ></ng-content>
    </fl-bit>
    <fl-bit class="HourlyAwardCTA-awardButton">
      <ng-content select="[hourly-award-cta-award-button]"></ng-content>
    </fl-bit>
  `,
  styleUrls: ['./hourly-award-cta-layout.component.scss'],
})
export class HourlyAwardCTALayoutComponent {}
